import React, { createContext, useContext, useState } from "react";
import { useLocation } from "react-router-dom";

const NavigationReferrer = createContext<string | null>(null);
export function NavigationReferrerProvider({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const url = window.location.origin + location.pathname + location.search;
  const [visit, setVisit] = useState({ key: location.key, url, referrer: document.referrer });
  if (visit.key !== location.key) {
    setVisit({ key: location.key, url, referrer: visit.url });
  }
  return <NavigationReferrer.Provider value={visit.referrer}>{children}</NavigationReferrer.Provider>;
}
export const useNavigationReferrer = () => useContext(NavigationReferrer) ?? document.referrer;
